const LOGO_BASE_PATH =
  '/wp-content/themes/sef-leagues/images/{abbrv}-team-logo.png"';

export const getTeamHeroInformation = (teamData) => {
  return {
    name: teamData.name,
    logoImageUrl: (teamData.logo) ? teamData.logo : teamData.logoImageUrl,
    leagueAndSeason: `${window.currentLeague} ${window.currentSeason}`,
    headerImageUrl: teamData.headerImageUrl
  };
};
